<div class="ir-item-line th-filter" *ngIf="inspection?.sections?.length">
  <div (click)="setOrderBy('name')" class="ir-item-cell s8 clickable">
    <span>
      <i class="material-icons" *ngIf="direction === 'asc'">arrow_drop_up</i>
      <i class="material-icons" *ngIf="direction === 'desc'">arrow_drop_down</i>
      {{ 'common.name' | translate }}
    </span>
  </div>
  <div (click)="setOrderBy('progression')" class="ir-item-cell s2 clickable right">
    <span>
      <i class="material-icons" *ngIf="direction === 'asc'">arrow_drop_up</i>
      <i class="material-icons" *ngIf="direction === 'desc'">arrow_drop_down</i>
      {{ 'common.status' | translate }}
    </span>
  </div>
</div>
<div class="ir-content-flow" [ngClass]="inspection?.sections?.length ? 'has-filter' : ''">
  <div class="ir-section--list">
    <div *ngIf="inspection">
      <div
        class="ir-item-line th-section clickable indent"
        [ngClass]="section.selected ? 'selected' : ''"
        (click)="openSection(section)"
        *ngFor="let section of inspection?.sections | orderBy : orderByFieldName : direction | searchBy : query"
      >
        <div class="ir-item-cell s8">
          <div class="ir-item-selector" *ngIf="selectable" (click)="selectSection($event, section)">
            <i class="material-icons" *ngIf="!section.selected">check_box_outline_blank</i>
            <i class="material-icons" *ngIf="section.selected">check_box</i>
          </div>
          <span>{{ section.order }}. {{ section.name }}</span>
        </div>
        <div class="ir-item-cell s2 right strong statut">
          <ng-container *ngFor="let session of section.sessions">
            <i
              *ngIf="session.user"
              class="material-icons"
              [title]="session.user"
              [style.color]="session.color"
              [class.disabled]="session.away"
              [class.away]="session.away"
              [class.active]="!session.away"
              >account_circle</i
            >
          </ng-container>
          <i *ngFor="let icon of section.icons | orderBy : 'order'" class="material-icons {{ icon.count !== 0 ? icon.classes : '' }}">{{
            icon.count !== 0 ? icon.name : ''
          }}</i>
          <span>{{ section?.getProgression() }} %</span>
        </div>
      </div>
    </div>
  </div>
  <div class="ir-item-empty ir-mv8" *ngIf="inspection?.sections?.length == 0">
    <div class="ir-section--list">
      <p>
        <span>{{ 'inspections.no-sections' | translate }}</span>
      </p>
    </div>
  </div>
</div>
